import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';
import { ServiciosService } from '../Servicios/servicios.service';
import { ModalController, NavController, Platform, PopoverController } from '@ionic/angular';
import { Device } from '@ionic-native/device/ngx';
import { Router } from '@angular/router';
import { VariablesService } from '../Servicios/variables.service';
import { EmpresasUsuario } from '../Modelos/empresas_usuario';
import { EmpresasUsuarioComponent } from './empresas-usuario/empresas-usuario.component';
import { globalConf } from '../Modelos/GlobalConf'

//import { Plugins } from '@capacitor/core';

//const { Storage } = Plugins;
import { Storage } from '@capacitor/storage'
import { AmPresenciaService } from '../Servicios/am-presencia.service';
import { ProcesosGlobalesService } from '../Servicios/procesos-globales.service';
import { LlamadasAlertsService } from '../Servicios/llamadas-alerts.service'




@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  public formularioLogin: FormGroup;
  public listaEmpresas: EmpresasUsuario[];
  public recordarUsuario: boolean;

  public version: string;


  constructor(
    private device: Device,
    private servicios: ServiciosService,
    private platform: Platform,
    private router: Router,
    public variables: VariablesService,
    private popoverController: PopoverController,
    private amservicio: AmPresenciaService,
    private procesosGlobalesService: ProcesosGlobalesService,
    private alerts: LlamadasAlertsService,
    public modalController: ModalController,
    public navCtrl: NavController

  ) {
    this.listaEmpresas = [];
    this.navCtrl.setDirection('root',true,'back');
  }

  ngOnInit() {
    this.version = globalConf.app_version;
    console.log("lista", this.listaEmpresas);
    this.crearFormulario();
    //this.servicios.presentLoading("Cargando Configuracion ...")

    //this.comprobarRecodarStorge();

  }

  async ionViewWillEnter() {
    await this.comprobarRecodarStorge();
  }

  crearFormulario() {
    this.formularioLogin = new FormGroup({
      loginUsuario: new FormControl('', Validators.compose([
        Validators.required,
        this.regexValidator()
      ])),
      passwordUsuario: new FormControl('', [Validators.required,this.regexValidator()]),
      recordarusuario: new FormControl()
    })
  }

  private regexValidator(): ValidatorFn  {
    return (control: AbstractControl): ValidationErrors | null => {
      let expresionRegularPass = /^(?!.*[\/\(;=\)%&\*|+\"\'\\\\]).*$/g
  
      if(expresionRegularPass.test(control.value)){
        return null //Cuando se devuelve null es que el formulario es correcto
      }else {
        return { valuesDoNotMach: true}
      }
  
    }
  }

  async login() {
    if (this.formularioLogin.valid == true && this.formularioLogin.dirty == true) {
      this.variables.usuario = this.formularioLogin.value.loginUsuario;
      this.variables.pwd = this.formularioLogin.value.passwordUsuario;
      //console.log('login if (this.formularioLogin.valid == true && this.formularioLogin.dirty == true) --> ', this.formularioLogin.valid , ' dirty ', this.formularioLogin.dirty)
    } else {
      //console.log('login else (this.formularioLogin.valid == true && this.formularioLogin.dirty == true) --> ', this.formularioLogin.valid , ' dirty ', this.formularioLogin.dirty)

      this.formularioLogin.value.loginUsuario = this.variables.usuario;
    }
    //console.log("recordar usuario ", this.recordarUsuario)
    if (this.recordarUsuario) {
      //console.log("store recordar usuario ", this.recordarUsuario)
      await this.procesosGlobalesService.guardarEnStorage('user', JSON.stringify(this.variables.usuario));
      await this.procesosGlobalesService.guardarEnStorage('pwd', JSON.stringify(this.variables.pwd));
      await this.procesosGlobalesService.guardarEnStorage('recordar', JSON.stringify(this.variables.recordarUsuario));

    } else {
      await Storage.clear();
    }

    this.variables.metodoAcceso = 'CredencialALO'

    //await this.servicios.presentLoading('Comprobando credenciales ...')

    this.amservicio.getTokenUsuario(this.formularioLogin.value.loginUsuario, this.formularioLogin.value.passwordUsuario)
      .subscribe(async (res) => {
        console.log("Token de usuario registrado correctamente");

        this.variables.tokenLogin = res;
        this.variables.loginCorrecto = true;

        await this.servicios.dissmisLoading()

        await this.alerts.presentLoading('Cargando empresas')

        this.servicios.obtenerListadoEmpresas(this.variables.usuario, this.variables.pwd).subscribe(
          async (next: EmpresasUsuario[]) => {
            //this.variables.loginCorrecto = true;
            //this.router.navigate(['tabs']);
            await this.alerts.dissmisLoading();
            this.listaEmpresas = [];
            this.listaEmpresas = next;

            //console.log("están todas ? ", this.listaEmpresas)
            this.variables.empresasUsuario = this.listaEmpresas;
            if (this.listaEmpresas) {

              if (this.listaEmpresas.length == 1) {
                this.variables.empresaSeleccionada = this.listaEmpresas[0];
                console.log("empresa selecionada cuanado es una", this.variables.empresaSeleccionada);
                this.router.navigate(['tabs'])

              } else {
                if (this.listaEmpresas.length != 0) {
                  this.seleccionarEmpresa(this.listaEmpresas)

                } else {
                  this.servicios.presentAlert("¡ Atencion !", "No tienes empresas válidas", "Las empresas o este usuario no cumplen los requisitos para utilizar esta aplicación")
                }
              }


            } else {
              this.servicios.presentAlert("¡ Atencion !", "No tienes empresas válidas", "Las empresas o este usuario no cumplen los requisitos para utilizar esta aplicación")
            }

          },
          error => {
            this.variables.loginCorrecto = false;
            this.variables.usuario = "";
            this.variables.pwd = "";
            console.log("error ", error);
          });

      }, async err => {
        console.log("Error al coger token del usuario");
        await this.alerts.dissmisLoading();
        await this.alerts.presentToast("Login Incorrecto", "danger", 2000);
      })

  }


  async seleccionarEmpresa(lista: EmpresasUsuario[]) {

    const modal = await this.modalController.create({
      component: EmpresasUsuarioComponent,
      componentProps: { "listaEmpresas": lista },
    });
    return await modal.present();
  };




  //this.listaDepartamentosResponsable();

  async cambiarRecordar() {
    this.recordarUsuario = !this.variables.recordarUsuario;
    //this.variables.recordarUsuario = !this.variables.recordarUsuario;
    //console.log("cambiar recordar ", this.recordarUsuario ,'  --  ', this.variables.recordarUsuario);

  }

  async comprobarRecodarStorge() {
    let valueUsr, valuePwd, valueRecordar = null;


    await this.procesosGlobalesService.obtenerEnStorage('recordar')
      .then((res) => {
        valueRecordar = res;
        console.warn("Valor de recordar Storage: ", res);
      })

    if (valueRecordar == true) {
      //this.formularioLogin.value.recordarusuario = true;
      this.variables.recordarUsuario = true;
      // console.log('Got item recordar: ', valueRecordar.value, ' variables ', this.variables.recordarUsuario);

      await this.procesosGlobalesService.obtenerEnStorage('user')
        .then((res) => {
          valueUsr = res;
          //console.log("Valor de Usuario Storage: ", res);
        })

      if (valueUsr) {
        //this.formularioLogin.value.loginUsuario = valueUsr.value;

        this.variables.usuario = valueUsr
        //console.log('Got item: usuario ', valueUsr.value, " variables ", this.variables.usuario);
      }

      await this.procesosGlobalesService.obtenerEnStorage('pwd')
        .then((res) => {
          valuePwd = res;
          //console.log("Valor de Pwd Storage: ", res);
        })

      if (valuePwd) {
        //this.formularioLogin.value.passwordUsuario = valuePwd;
        this.variables.pwd = valuePwd;
        //console.log('Got item: password', valuePwd.value , ' variables ', this.variables.pwd)
      };
      this.recordarUsuario = true;
    } else {
      this.variables.recordarUsuario = false;
      this.variables.usuario = '';
      this.variables.pwd = '';
      this.recordarUsuario = false;
      //console.log("valueRecordar.value == 'false'", valuePwd.value , ' variables ', this.variables.pwd)

    }
    //console.log('Got item recordar final : ', valueRecordar.value, ' variables ', this.variables.recordarUsuario);
  }

}
